export class AlcoholUsage {
    constructor(alcohol, timeh, timem, percentage) {
      this.alcohol = alcohol;
      this.timeh = timeh;
      this.timem = timem;
      this.percentage = percentage;
    }
  }